// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { infoCardsWidgetStyles } from "@pace/App/Widgets/WhyPace/InfoCardsWidget";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

infoCardsWidgetStyles.container = {
    css: css`
        padding-top: 0;
        gap: 24px 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        @media print {
            page-break-inside: avoid;
        }
    `,
};
infoCardsWidgetStyles.content = {
    css: css`
        border: 1px solid ${color("common.ui12")};
        border-radius: 4px;
        ${({ numberOfCards }: any) => {
            if (numberOfCards >= 4) {
                return css`
                    width: calc((100% - 60px) / 4);
                    ${xScreen("lte", "md")} {
                        width: calc(50% - 10px);
                    }
                `;
                // eslint-disable-next-line no-else-return
            } else if (numberOfCards === 2) {
                return css`
                    width: calc((100% - 20px) / 2);
                    ${xScreen("lte", "md")} {
                        width: calc(50% - 10px);
                    }
                `;
            } else if (numberOfCards === 3) {
                return css`
                    width: calc((100% - 40px) / 3);
                    ${xScreen("lte", "md")} {
                        width: calc(50% - 10px);
                    }
                `;
            } else {
                return css`
                    width: 100%;
                `;
            }
        }}
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};
